import { combineReducers } from 'redux';
import customerReducer from './CustomerReducer';
import authReducer from './AuthReducer';
import userReducer from './UserReducer';
import holidaysReducer from "./HolidaysReducer";

export default combineReducers({
    customers: customerReducer,
    auth: authReducer,
    user: userReducer,
	holidays: holidaysReducer
});
